import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M 26 56 l 1.6 8.4 s 3.6 2 8.8 2 c 5.84 0 12.24 -2.88 12.24 -8.56 c 0 -12.32 -28.88 -7.2 -28.88 -26.32 c 0 -11.2 8.96 -15.92 18.96 -15.92 c 7.6 0 16.88 3.2 16.88 3.2 l -0.4 13.6 l -5.2 0 l -2.72 -8.56 s -4.08 -1.44 -8.48 -1.44 c -7.2 0 -10.64 3.76 -10.64 7.76 c 0 12.16 28.8 7.52 28.8 25.52 c 0 12 -9.68 17.52 -20.88 17.52 c -8.4 0 -16.48 -3.2 -16.48 -3.2 l 0 -14 l 6.4 0 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
